export default __webpack_public_path__ + "static/media/book-table-head-banner.87174b3d.jpg";